module.exports = __webpack_public_path__ + "media/src/images/viewbtn/fullsize-off-38b5313f2012a65fcad74a8d4b7c180b.png";